/* eslint-disable no-nested-ternary */
import {
  useElement,
  useState,
  useStaleLayout,
  useRect,
  useEffect,
} from '@nebula.js/stardust';
import picassojs from 'picasso.js';
import picassoQ from 'picasso-plugin-q';
import picassoHammer from 'picasso-plugin-hammer';
// import numeral from 'numeral';

import * as d3 from 'd3';

export default function supernova() {
  const picasso = picassojs();
  picasso.use(picassoQ);
  picasso.use(picassoHammer);

  return {
    qae: {
      properties: {
        qHyperCubeDef: {
          qDimensions: [],
          qMeasures: [],
          qInitialDataFetch: [{ qWidth: 3, qHeight: 3300 }],
          qSuppressZero: false,
          qSuppressMissing: true,
        },
        showTitles: true,
        title: '',
        subtitle: '',
        footnote: '',
      },
      data: {
        targets: [
          {
            path: '/qHyperCubeDef',
            dimensions: {
              min: 1,
              max: 2,
            },
            measures: {
              min: 1,
              max: 1,
            },
          },
        ],
      },
    },
    component() {
      const element = useElement();
      const layout = useStaleLayout();
      const rect = useRect();

      const [instance, setInstance] = useState();

      useEffect(() => {
        const p = picasso.chart({
          element,
          data: [],
          settings: {},
        });

        setInstance(p);

        return () => {
          p.destroy();
        };
      }, []);

      useEffect(() => {
        if (!instance) {
          return;
        }

        const layoutData = layout.qHyperCube.qDataPages[0].qMatrix;

        const domain = layout.qHyperCube.qDimensionInfo[1].qFallbackTitle === '[Race - Comp]' ? ['White', 'Unknown', 'Asian', 'Indigenous', 'Mixed Race', 'Black', 'Middle Eastern', 'Latin']
          : (layout.qHyperCube.qDimensionInfo[1].qFallbackTitle === '[Gender - Comp]' ? ['Men', 'Women', 'Non-Binary'] : ['Supervisors', 'Full-Time', 'Part-Time', 'Interns']);

        const range = layout.qHyperCube.qDimensionInfo[1].qFallbackTitle === '[Race - Comp]' ? ['#A7A4D4', '#204635', '#C17A82', '#408CA0', '#6BE0DD', '#A55886', '#E8CEAA', '#A2C3B4']
          : (layout.qHyperCube.qDimensionInfo[1].qFallbackTitle === '[Gender - Comp]' ? ['#9EBFCE', '#BE7999', '#204635'] : ['#CDB3A2', '#24796C', '#2F8AC4', '#B890D3']);

        const colorScale = d3.scaleOrdinal()
          .domain(domain)
          .range(range);

        const nbrEmpChange = {};

        layoutData.forEach((d) => {
          if (Object.prototype.hasOwnProperty.call(nbrEmpChange, d[1].qText)) {
            nbrEmpChange[d[1].qText] = (((d[2].qNum - nbrEmpChange[d[1].qText]) / nbrEmpChange[d[1].qText]) * 100).toFixed(1);
          } else {
            nbrEmpChange[d[1].qText] = d[2].qNum;
          }
        });

        instance.update({
          data: [
            {
              type: 'q',
              key: 'qHyperCube',
              data: layout.qHyperCube,
            },
          ],
          settings: {
            strategy: {
              center: {
                minWidthRatio: 0,
              },
              layoutModes: {
                S: { width: 400, height: 50 },
              },
            },
            formatters: {
            },

            scales: {
              x: {
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                  },
                },
                paddingInner: 0.9,
                paddingOuter: 0,
              },
              color: {
                data: {
                  extract: {
                    field: 'qDimensionInfo/1',
                  },
                },
                type: 'color',
              },
              y: {
                data: {
                  field: 'qMeasureInfo/0',
                },
                invert: true,
                expand: 0.07,
                type: 'linear',
              },
              yend: {
                data: {
                  field: 'qMeasureInfo/0',
                },
                invert: true,
                expand: 0.07,
                type: 'linear',
              },
            },
            components: [
              {
                type: 'axis',
                key: 'x-axis',
                scale: 'x',
                dock: 'bottom',
                settings: {
                  labels: {
                    show: true,
                    fontSize: '12px',
                    mode: 'horizontal',
                  },
                },
              },
              {
                type: 'axis',
                key: 'y-axis',
                scale: 'y',
                settings: {
                  labels: {
                    show: true,
                    mode: 'layered',
                    fontSize: '11px',
                    filterOverlapping: false,
                  },
                },
                layout: {
                  show: true,
                  dock: 'left',
                  minimumLayoutMode: 'S',
                },
              },
              {
                type: 'axis',
                key: 'y-axis-end',
                scale: 'yend',
                settings: {
                  labels: {
                    show: true,
                    mode: 'layered',
                    fontSize: '11px',
                    filterOverlapping: false,
                  },
                },
                layout: {
                  show: true,
                  dock: 'right',
                },
              },
              {
                type: 'line',
                key: 'lines',
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                    props: {
                      y: {
                        field: 'qMeasureInfo/0',
                      },
                      series: {
                        field: 'qDimensionInfo/1',
                      },
                    },
                  },
                },
                settings: {
                  coordinates: {
                    major: {
                      scale: 'x',
                    },
                    minor: {
                      scale: 'y',
                      ref: 'y',
                    },
                    // minor0: {
                    //   scale: 'y',
                    // },
                    layerId: {
                      ref: 'series',
                    },
                  },
                  // orientation: 'horizontal',
                  layers: {
                    // sort: (a, b) => a.id - b.id,
                    // curve: 'monotone',
                    line: {
                      // stroke: {
                      //   scale: 'color',
                      //   ref: 'series',
                      // },
                      stroke: (d) => colorScale(d.datum.series.label),
                      strokeWidth: 3,
                      opacity: 0.9,
                    },
                  },
                },
              },
              // {
              //   type: 'legend-cat',
              //   scale: 'color',
              //   key: 'legend',
              //   dock: 'bottom',
              //   settings: {
              //     title: {
              //       show: false,
              //     },
              //     layout: {
              //       size: 2,
              //     },
              //   },
              // },
              {
                type: 'point',
                key: 'point',
                displayOrder: 1,
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                    props: {
                      x: {
                        field: 'qDimensionInfo/0',
                      },
                      y: {
                        field: 'qMeasureInfo/0',
                      },
                      dim: {
                        field: 'qDimensionInfo/1',
                      },
                      // rank: {
                      //   field: 'qMeasureInfo/1',
                      // },
                      // rev: {
                      //   field: 'qMeasureInfo/2',
                      // },
                      // prof: {
                      //   field: 'qMeasureInfo/3',
                      // },
                    },
                  },
                },
                settings: {
                  x: { scale: 'x' },
                  y: { scale: 'y' },
                  shape: 'circle',
                  size: 0.2,
                  strokeWidth: 2,
                  // stroke: '#5D627E',
                  fill: (d) => colorScale(d.datum.dim.label),
                  opacity: 0.9,
                },
              },
              {
                key: 'tooltip',
                type: 'tooltip',
                displayOrder: 10,
                settings: {
                  // Target point marker
                  filter: (nodes) => nodes.filter((node) => node.key === 'point' && node.type === 'circle'),
                  // Extract data
                  extract: ({ node }) => {
                    const obj = {};

                    obj.year = node.data.x.label;
                    obj.dim = node.data.dim.label;
                    obj.nbrEmployees = node.data.y.label;
                    obj.nbrEmpChange = nbrEmpChange[obj.dim];

                    return obj;
                  },
                  // Generate content
                  content: ({ h, data }) => {
                    const els = [];
                    let elarrow = null;
                    let empCh = '';
                    data.forEach((node) => {
                      // Title
                      const elh = h('td', {
                        colspan: '3',
                        style: { fontWeight: 'bold', 'text-align': 'left', padding: '0 5px' },
                      }, `${node.year} ${node.dim}`);

                      const el1 = h('td', { style: { padding: '0 5px' } }, 'Number of Employees');
                      const el2 = h('td', { style: { padding: '0 5px' } }, `${node.nbrEmployees}`);
                      // nbrEmp Change
                      if (node.nbrEmpChange > 0 && node.year !== '2021') {
                        empCh = `+${node.nbrEmpChange}%`;
                        elarrow = h('div', {
                          style: {
                            width: '0px',
                            height: '0px',
                            'border-left': '5px solid transparent',
                            'border-right': '5px solid transparent',
                            'border-bottom': '5px solid #008000',
                          },
                        }, '');
                      } else if (node.nbrEmpChange < 0 && node.year !== '2021') {
                        empCh = `${node.nbrEmpChange}%`;
                        elarrow = h('div', {
                          style: {
                            width: '0px',
                            height: '0px',
                            'border-left': '5px solid transparent',
                            'border-right': '5px solid transparent',
                            'border-top': '5px solid #FF0000',
                          },
                        }, '');
                      } else {
                        empCh = '';
                        elarrow = '';
                      }
                      // Rest of Info
                      const el3 = h('td', {
                        style: {
                          display: 'flex',
                          alignItems: 'center',
                        },
                      }, [empCh, elarrow]);
                      const elr1 = h('tr', {}, [el1, el2, el3]);
                      els.push(h('tr', {}, [elh]), elr1);
                    });

                    return h('table', {}, els);
                  },
                  placement: {
                    type: 'pointer',
                    area: 'target',
                    dock: 'auto',
                  },
                },
              },
            ],
            interactions: [
              {
                type: 'native',
                events: {
                  mousemove(e) {
                    this.chart.component('tooltip').emit('show', e);
                  },
                  mouseleave() {
                    this.chart.component('tooltip').emit('hide');
                  },
                },
              },
              {
                type: 'hammer',
                gestures: [
                  {
                    type: 'Tap',
                    events: {
                      tap(e) {
                        this.chart.component('tooltip').emit('show', e);
                      },
                    },
                  },
                ],
              },
            ],
          },
        });
      }, [layout, instance]);

      useEffect(() => {
        if (!instance) {
          return;
        }
        instance.update();
      }, [rect.width, rect.height, instance]);
    },
  };
}
